module.exports = __webpack_public_path__ + "img/paynow.e011c67d.png";